import { Stack, useTheme } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FormDateTimePicker from '../form-date-time-picker/FormDateTimePicker';
import { FormFieldPropsBase } from '../form/Form';
import { isValid as isDateValid } from "date-fns";

export type FormDateRangeProps = {
    // startDate: string,
    // endDate: string,
    spacing?: ResponsiveStyleValue<string | number>;
    size?: "small" | "medium" | undefined;
} & FormFieldPropsBase;

export default function FormDateRange({
    name,
    // id,
    // testId,
    // label,
    // ariaLabel,
    readOnly,
    // helperText,
    sx,

    //startDate,
    //endDate,
    disabled,
    spacing,
    size

}: FormDateRangeProps) {

    const { control, getValues } = useFormContext();
    const { t } = useTranslation();
    const theme = useTheme();

    const _isInValidateStartDate = (value: string): string | undefined => {

        let message: string | undefined = undefined;

        const start = new Date(value);
        const end = getValues<any>(`${name}.endDate`) as Date;

        if (!isDateValid(start)) {

            message = t('customDuration.validStartDate') as string;

        } else if (start.getTime() > end.getTime()) {

            message = t('customDuration.startBeforeEndError') as string;
        }

        return message;
    };

    const _isInValidateEndDate = (value: string): string | undefined => {

        let message: string | undefined = undefined;

        const end = new Date(value);
        const start = getValues<any>(`${name}.startDate`) as Date;

        if (!isDateValid(end)) {

            message = t('customDuration.validEndDate') as string;

        } else if (start.getTime() > end.getTime()) {
            message = t('customDuration.startBeforeEndError') as string;
        }

        return message;
    };

    return (
        <Controller
            control={control}
            name={name}

            render={
                ({
                    field: {
                        ref,
                        name,
                        value,
                        onChange,
                        onBlur,
                    },
                    fieldState: {
                        invalid,
                        isTouched,
                        isDirty,
                        error
                    },
                    formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={spacing ?? 2} sx={sx}>
                        <FormDateTimePicker
                            name={`${name}.startDate`}
                            ariaLabel='start date'
                            disabled={disabled}
                            readOnly={readOnly}
                            label={t("datetime.startTime")}
                            //helperText={error ? 'Invalid start date' : undefined}
                            sx={{
                                width: '100%'
                            }}
                            rules={!disabled ? {
                                required: t('customDuration.validStartDate'),
                                validate: (value: any) => _isInValidateStartDate(value)
                            } : undefined}
                            size={size}
                        />

                        <FormDateTimePicker
                            //name="endDate"
                            name={`${name}.endDate`}
                            ariaLabel='end date'
                            disabled={disabled}
                            readOnly={readOnly}                            
                            label={t("datetime.endTime")}
                            sx={{
                                width: '100%',
                                color: error ? theme.palette.error.main : 'undefined'
                            }}
                            rules={!disabled ? {
                                required: t('customDuration.validEndDate'),
                                validate: (value: any) => _isInValidateEndDate(value)
                            } : undefined}
                            size={size}
                        />
                    </Stack>
                )
            }
        />
    );
}
